export default {
    type: {
        "ac_router": "Dosáhli jste limitu objednávek AC routerů",
        "chair": "Dosáhli jste limitu objednávek židlí",
        "default": "Dosáhli jste limitu objednávek",
        "default_multiple": "Dosáhli jste limitu objednávek podobných produktů",
        "desk": "Dosáhli jste limitu objednávek stolů",
        "desktop": "Dosáhli jste limitu objednávek pro stolní počítače",
        "desktop_riser": "Dosáhli jste limitu objednávek stolních podstavců",
        "detector": "Dosáhli jste limitu objednávek vaporizérů a detektorů hluku",
        "displayport_cable": "Dosáhli jste limitu objednávek kabelů DisplayPort.",
        "docking station": "Dosáhli jste limitu objednávek dokovacích stanic",
        "dual_usb_adapter": "Dosáhli jste limitu objednávek dvoupásmových USB adaptérů",
        "ear cushion": "Dosáhli jste limitu objednávek náušníků",
        "footrest": "Dosáhli jste limitu objednávek podnožek",
        "hdmi_cable": "Dosáhli jste limitu objednávek HDMI kabelů",
        "hdmi_displayport_cable": "Dosáhli jste limitu objednávek kabelů HDMI-DisplayPort.",
        "hdmi_vga_cable": "Dosáhli jste limitu objednávek kabelů HDMI-VGA",
        "headset": "Dosáhli jste limitu objednávek audio zařízení",
        "keyboard": "Dosáhli jste limitu objednávek klávesnic",
        "kvm switch": "Dosáhli jste limitu objednávek KVM přepínačů.",
        "kvm_switch": "Dosáhli jste limitu objednávek KVM přepínačů.",
        "lamp": "Dosáhli jste limitu objednávek lamp",
        "laptop stand": "Dosáhli jste limitu objednávek stojanů na notebooky",
        "laptop": "Dosáhli jste limitu objednávek notebooků",
        "mesh_router": "Dosáhli jste limitu objednávek síťových routerů",
        "monitor": "Dosáhli jste limitu objednávek monitorů",
        "mouse": "Dosáhli jste limitu objednávek myší",
        "patch_cord": "Dosáhli jste limitu objednávek patchcordů Cat6",
        "power": "Dosáhli jste limitu objednávek napájecích kabelů",
        "power_center": "Dosáhli jste limitu objednávek energetických center",
        "power_strip": "Dosáhli jste limitu objednávek prodlužovacích kabelů",
        "printer": "Dosáhli jste limitu objednávek tiskáren.",
        "smart_plug": "Dosáhli jste limitu objednávek chytrých mini zásuvek",
        "smart_power_strip": "Dosáhli jste limitu objednávek chytrých prodlužovacích kabelů",
        "speakerphone": "Dosáhli jste limitu objednávek hlasitých telefonů",
        "stylus": "Dosáhli jste limitu objednávek stylusů",
        "tablet": "Dosáhli jste limitu objednávek tabletů",
        "tablet accessory": "Dosáhli jste limitu objednávek příslušenství k tabletům",
        "thunderbolt_cable": "Dosáhli jste limitu objednávek USB-C na Thunderbolt",
        "travel_router": "Dosáhli jste limitu objednávek cestovních routerů",
        "usb hub": "Dosáhli jste limitu objednávek USB hubů",
        "usb_adapter": "Dosáhli jste limitu objednávek USB adaptérů",
        "usb_hub": "Dosáhli jste limitu objednávek USB hubů",
        "webcam": "Dosáhli jste limitu objednávek webových kamer"
    }
}